import React, { useState } from "react";
import { safeLocalStorageSetItem } from "utils/localStorage";
import { ArrowRightIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { Button } from "components/Graphs/Button";
import { useHistory } from "react-router-dom";
import { STORAGE_KEYS } from "constants/localStorage";
import LobsterIcon from "assets/img/svg/lobster.svg?react";

const DISMISS_KEY = STORAGE_KEYS.nemoClawBannerDismissed;

const NemoClawPromoBanner: React.FC = () => {
  const history = useHistory();
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(DISMISS_KEY) === "true",
  );

  if (dismissed) return null;

  const handleDismiss = () => {
    setDismissed(true);
    safeLocalStorageSetItem(DISMISS_KEY, "true");
  };

  return (
    <div className="bg-secondaryBg border border-zinc-800 rounded-md mt-4 shadow-lg">
      <div className="bg-gradient-to-r from-[#76b900]/10 via-[#76b900]/5 to-transparent border-l-4 border-[#76b900] rounded-md">
        <div className="px-6 py-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4 flex-1">
              <div className="flex-shrink-0">
                <div className="h-10 w-10 rounded-lg bg-gradient-to-br from-[#76b900]/20 to-[#76b900]/10 flex items-center justify-center">
                  <LobsterIcon className="h-6 w-6 [&_path]:fill-[url(#lobsterGradient)]" />
                </div>
              </div>
              <div className="flex-1">
                <h3 className="text-sm font-semibold text-primary">
                  Your agents are waiting.{" "}
                  <span className="inline-flex items-center gap-1 text-[#76b900]">
                    Meet NemoClaw
                    <ArrowRightIcon aria-hidden="true" className="h-4 w-4" />
                  </span>
                </h3>
                <p className="text-xs text-secondary mt-0.5">
                  Always-on, self-evolving AI agents with NVIDIA OpenShell
                  guardrails. Runs on low-cost machines and connects to hosted
                  AI models for you — no expensive hardware needed.
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3 ml-4">
              <Button
                variant="secondary"
                onClick={() => history.push("/nemoclaw")}
                className="whitespace-nowrap border-[#76b900]/40 text-[#76b900] hover:border-[#76b900]/70"
              >
                Try NemoClaw
              </Button>
              <button
                onClick={handleDismiss}
                className="text-secondary hover:text-primary transition-colors p-1 rounded hover:bg-secondaryBg"
                aria-label="Dismiss banner"
              >
                <XMarkIcon className="h-5 w-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NemoClawPromoBanner;
